export default "__VITE_ASSET__By65rmnc__"